import { Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { JustificationDisplay } from "./justification-display"
import { Bound } from "lib/@components/binding/Bound"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { BlockClicks } from "lib/@components/block-clicks"

export function ViewJustification() {
    const { tailoringAudit, setJustification } = useBoundContext()

    const createdOn = new Date(tailoringAudit?.date).format(DATE_FORMATS.long)

    return (
        <BlockClicks sx={{ width: 1, display: "block" }}>
            <Stack
                backgroundColor="grey.200"
                spacing={1}
                sx={{ borderRadius: 1 }}
                p={1}
                px={1.5}
                my={1}
                data-cy="view-tailored-justification"
            >
                <Bound createdOn={createdOn} createdBy={tailoringAudit?.userName}>
                    <JustificationDisplay payload={tailoringAudit?.payload} onEdit={handleEdit} />
                </Bound>
            </Stack>
        </BlockClicks>
    )

    function handleEdit() {
        setJustification({
            reason: tailoringAudit?.payload?.reason,
        })
    }
}
